import { ShowActor } from './showActor';

/**
 * Author roles that outrank a student leader, as they appear on denormalised
 * author/uploader fields. Port of `mobile_app/lib/permissions/content_moderation.dart`.
 */
export const STAFF_AUTHOR_ROLES: ReadonlySet<string> = new Set(['teacher', 'org_admin', 'admin', 'super_admin']);

/**
 * Whether `actor` may delete content whose recorded author role is
 * `authorRole`. The client half of the backend's `canModerateAuthoredContent`.
 *
 * Authored content (posts, comments, gallery photos) is rank-aware: a leader
 * may remove what students and other leaders wrote, never a teacher's. Library
 * content (resources, folders) is flat and never comes here - the asymmetry is
 * the product rule.
 *
 * Compose with `moderateShowPost` / `moderateGalleryPhoto`, and keep the
 * author-acts-on-own branch at the call site. Fails closed on an unknown
 * author, because there is no way to tell whether a teacher wrote it.
 */
export function canModerateAuthoredContent(actor: ShowActor, authorRole: string | null | undefined): boolean {
  switch (actor) {
    case 'showStaff':
    case 'orgAdmin':
    case 'superAdmin':
      return true;
    case 'showLeader':
      if (!authorRole) return false;
      return !STAFF_AUTHOR_ROLES.has(authorRole.toLowerCase());
    default:
      return false;
  }
}
